// extracted by mini-css-extract-plugin
export default {"root":"GoalSetterForm__root","compact":"GoalSetterForm__compact","inline":"GoalSetterForm__inline"};